namespace SP {
    export class ShippingMethodParameterType {
        static string = "string";
        static password = "password";
        static integer = "integer";
        static decimal = "decimal";
        static boolean = "boolean";
        static datetime = "datetime";
        static options = "options";
        static bigtext = "bigtext";
        static timeofday = "timeofday";
        static date = "date";
    }
}